export interface CurrentLevel {
	id: number;
	level: number;
	progress: number;
	total: number;
}

export interface Answer {
	id: number | string;
	content?: string;
	answer_text?: string;
	answer_display?: string;
	answer_variations?: { answer_text: string }[];
	blank_index?: number;
	correct?: boolean;
	is_correct?: boolean;
}

export type GameAnswer = Answer;

export type QuestionDisplay = string | (string | Record<string, unknown>)[];

export interface Question {
	id: number;
	ai_tutor_enabled: boolean;
	explanation_available: boolean;
	question_display: QuestionDisplay;
	time_estimate_in_seconds: number;
	title: string;
	topic_id: number;
	topic_title: string;
	type: string;
	answers?: GameAnswer[];
	decoy_letters?: string[];
}

export interface GameData {
	id: number;
	correct_answers_count: number;
	difficulty_level: number;
	free_play_theme: string;
	image: string;
	is_intervention_section: boolean;
	is_mistake: boolean;
	playlist_section_text: {
		title: string | null;
		text: string | null;
	};
	questions: Question[];
	questions_count: number;
	relative_difficulty: string;
	section_type: string;
	title: string;
	topic_subcategory_id: number | null;
	topic_subcategory_name: string;
	wrong_answers_count: number;
	total_time: number;
	game?: {
		type: string;
		total_time_in_seconds: number;
		reward_attribute: string;
		correct_answer_streak: number;
		high_score?: number;
		reward: {
			correct_answer_streak: Record<number, number>;
			wrong_answer_streak: Record<number, number>;
		};
	};
}

export enum EndOutcome {
	SUCCEEDED = 'succeeded',
	LOST = 'lost',
	ABANDONED = 'abandoned',
}

export interface GameAnswerEvent {
	gameType: string;
	question: Question;
	questionIndex: number;
	isCorrect: boolean;
	answer?: GameAnswer;
	answerIndex?: number;
	answerId?: number | string | null;
	answerTexts?: string[];
	answerTimeInSeconds?: number;
	isSecondAttempt?: boolean;
	score?: number;
	data?: Record<string, unknown>;
	finishEvent?: GameFinishEvent;
}

export interface GameFinishEvent {
	gameOutcome: EndOutcome;
	score?: number;
	data?: Record<string, unknown>;
}

export interface GameCloseEvent {
	finishEvent?: GameFinishEvent;
}

export interface GameAudioChangeEvent {
	audioOn: boolean;
}

export interface GameAudioProps {
	audioOn?: boolean;
	onAudioChange?: (event: GameAudioChangeEvent) => void;
}

export interface GameActionPayload {
	currentLevel?: CurrentLevel;
	gameData?: GameData;
	isCorrect?: boolean;
	gameDataId?: number | string;
	freePlayCategoryId?: number | string;
	gameOutcome?: EndOutcome;
	score?: number;
	data?: Record<string, unknown>;
}

export interface GameAction {
	type: string;
	payload?: GameActionPayload;
}

export interface GameState {
	loading: boolean;
	currentLevel?: CurrentLevel | null;
	gameData?: GameData | null;
	questions: Question[];
}
